const UserEditFormMode = {
    none: 0,
    add: 1,
    edit:2
};

const UserEditDialogForm = {
    none: 0,
    add: 1,
    importFromDirectory: 2
};

export { UserEditFormMode, UserEditDialogForm };


// WEBPACK FOOTER //
// ./src/services/enums/users.js